import { jsxs as d, jsx as l } from "react/jsx-runtime";
import { forwardRef as k } from "react";
const c = {
  primary: "aiskills-btn aiskills-btn--primary",
  secondary: "aiskills-btn aiskills-btn--secondary",
  danger: "aiskills-btn aiskills-btn--danger",
  ghost: "aiskills-btn aiskills-btn--ghost"
}, p = {
  sm: "aiskills-btn--sm",
  md: "aiskills-btn--md",
  lg: "aiskills-btn--lg"
}, g = k(function({
  variant: a = "primary",
  size: i = "md",
  isLoading: s = !1,
  disabled: n,
  className: t,
  children: r,
  type: o,
  ...e
}, b) {
  const m = [c[a], p[i], t].filter(Boolean).join(" ");
  return /* @__PURE__ */ d(
    "button",
    {
      ref: b,
      type: o ?? "button",
      className: m,
      disabled: n || s,
      "aria-busy": s || void 0,
      ...e,
      children: [
        s ? /* @__PURE__ */ l("span", { "aria-hidden": "true", className: "aiskills-btn__spinner" }) : null,
        /* @__PURE__ */ l("span", { className: "aiskills-btn__label", children: r })
      ]
    }
  );
});
export {
  g as Button
};
//# sourceMappingURL=Button.js.map
